import { render, staticRenderFns } from "./rosteringrule.vue?vue&type=template&id=5de315df&scoped=true&"
import script from "./rosteringrule.vue?vue&type=script&lang=js&"
export * from "./rosteringrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de315df",
  null
  
)

export default component.exports